import PropTypes from 'prop-types';
import React, { Component } from 'react';
import 'stylesheets/design_system_legacy.scss';

export default class DownloadModalPage extends Component {
  static propTypes = {
    title: PropTypes.string,
    closeModal: PropTypes.func,
  };

  render() {
    const handleDismiss = () => {
      if (this.props.closeModal) {
        this.props.closeModal();
      }
    };

    return (
      <div className="DesignSystem">
        <div className="container-fluid u-ph0x" style={{ minHeight: '402px' }}>
          <span
            className="u-floatRight u-clickable u-mt3x u-mr3x u-tcGrayDark u-fs28 u-fw300"
            data-dismiss="modal"
            onClick={handleDismiss}
          >
            ×
          </span>
          {this.props.title ? (
            <h1 className="u-lineHeight1_1 u-taCenter u-fs14 u-tcGrayDarkest u-fw400  u-mb4x u-pt8x">
              {this.props.title}
            </h1>
          ) : null}
          {this.props.children}
        </div>
      </div>
    );
  }
}
